import { faListCheck } from '@fortawesome/free-solid-svg-icons';
import { memo } from 'react';

import NestedDataList from '@/components/NestedDataList/NestedDataList';
import useAPI from '@/hooks/useAPI';
import TimelineHeader from '@/pages/Timeline/components/TimelineHeader/TimelineHeader';
import TimestampAndActor from '@/pages/Timeline/components/TimestampAndActor';
import { TimelineSubcomponentProps } from '@/pages/Timeline/types';
import SurveyRepository from '@/repositories/SurveyRepository';
import Accordion from '@/ui/components/Accordion/Accordion';
import Spinner from '@/ui/components/Spinner';

// const logdataExample = {
//   backfill: true,
//   form_key: 'NIDA grant - Stimulants - Phase 1 (2021 - 2022)',
//   submitted_datetime: '2021-12-02T11:21:02.000+00:00'
// };

const SurveyEvent = ({ activityLog, title = 'Survey Submission' }: TimelineSubcomponentProps) => {
  const { actor, data: activityLogData, object_id, timestamp } = activityLog;
  const surveyRepository = SurveyRepository();

  const {
    data: survey,
    isPending,
    refetch: getSurvey
  } = useAPI({
    queryKey: ['getSurvey', [object_id]],
    queryFn: async () => {
      return await surveyRepository.getSurvey(object_id);
    },
    enabled: false
  });

  const getSubtitle = () => {
    return activityLogData?.source
      ? `${activityLogData?.form_key} (${activityLogData?.source})`
      : activityLogData?.form_key;
  };

  return (
    <div>
      <div className="mb-2">
        <Accordion
          buttonText={
            <TimelineHeader
              icon={faListCheck}
              iconClassName="text-blue-500"
              subtitle={getSubtitle()}
              title={title}
            />
          }
          onClick={getSurvey}>
          {isPending ? (
            <Spinner />
          ) : (
            <>
              {survey ? (
                <NestedDataList data={survey.normalized_data} sensitive />
              ) : (
                <div>Unable to retrieve survey data</div>
              )}
            </>
          )}
        </Accordion>
      </div>

      <TimestampAndActor actor={actor} timestamp={timestamp} />
    </div>
  );
};

export default memo(SurveyEvent);
